import * as home from './request/home'
import * as personal from './request/personal'

export default {
    home: home,
    personal: personal
}